// The Django shell no longer renders these; kept for tabs opened before that change, since PostHog and RUM record every <body> attribute.
export const LEGACY_BODY_CREDENTIAL_ATTRIBUTES = [
  'api_admin_token',
  'jwt_admin_token',
  'api_key',
  'preview_identity_token',
] as const;

export function stripLegacyBodyCredentials(): void {
  LEGACY_BODY_CREDENTIAL_ATTRIBUTES.forEach((attribute) =>
    document.body?.removeAttribute(attribute),
  );
}
